import { render, staticRenderFns } from "./UserView.vue?vue&type=template&id=c98e9194&lang=pug&"
import script from "./UserView.vue?vue&type=script&lang=ts&"
export * from "./UserView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports